import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ImageHandler from './ImageHandler';
import Input from '../../Input';
import produce from 'immer';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Edit } from '../../../assets/svg/edit.svg';
import { ReactComponent as Add } from '../../../assets/svg/add.svg';
import { useImages } from '../../../hooks/useImages';
import Modal from '../../Modal';
import Button from '../../Button';
import clean from 'clean-deep';

const LessonEditDataUnion = ({ data = [], onChange = () => {} }) => {
  const [state, setState] = useState([]);

  const [extractedImages, setExtractedImages] = useState([]);

  const images = useImages(extractedImages);

  const [showItemModal, setShowItemModal] = useState(undefined);
  const [itemText1, setItemText1] = useState('');
  const [itemImage1, setItemImage1] = useState(undefined);

  const [itemText2, setItemText2] = useState('');
  const [itemImage2, setItemImage2] = useState(undefined);

  useEffect(() => {
    const state = formatState(data);
    setState(state);
    setExtractedImages(() => {
      let res = [];
      state.map((i) => {
        res.push(i.image1);
        res.push(i.image2);
      });
      return res;
    });
  }, [data]);

  useEffect(() => {
    onChange({
      data: clean(translateState(state)),
    });
  }, [state, onChange]);

  const isLoaded = ({ image }) => (image && images[image]) || !image;

  const onDeleteItem = (index) =>
    setState(
      produce((state) => {
        state.splice(index, 1);
      })
    );

  const onAddItem = () => {
    setItemImage1(undefined);
    setItemText1('');

    setItemImage2(undefined);
    setItemText2('');

    setShowItemModal({
      submit: 'Agregar',
      onSubmit: ({ text1, image1, text2, image2 }) => {
        setExtractedImages((state) => [...state, image1, image2]);
        setState(
          produce((state) => {
            state.push({
              text1: (text1 || '').trim(),
              image1,
              text2: (text2 || '').trim(),
              image2,
            });
          })
        );
        setShowItemModal(undefined);
      },
    });
  };

  const onEditItem = (index) => {
    setItemImage1(state[index].image1);
    setItemText1(state[index].text1);
    setItemImage2(state[index].image2);
    setItemText2(state[index].text2);

    setShowItemModal({
      submit: 'Guardar',
      onSubmit: ({ text1, image1, text2, image2 }) => {
        setExtractedImages((state) => [...state, image1, image2]);
        setState(
          produce((state) => {
            state[index].text1 = (text1 || '').trim();
            state[index].image1 = image1;
            state[index].text2 = (text2 || '').trim();
            state[index].image2 = image2;
          })
        );
        setShowItemModal(undefined);
      },
    });
  };

  return (
    <Container>
      {showItemModal && (
        <ModalStyled>
          <ModalContainer>
            <ModalBody>
              <Sector>
                <Handlers>
                  <ImageHandler image={itemImage1} onChange={(obj) => setItemImage1(obj.name)} />
                </Handlers>
                <Input
                  placeholder='Texto 1'
                  value={itemText1}
                  onChange={(e) => setItemText1(e.target.value)}
                />
              </Sector>
              <Sector>
                <Handlers>
                  <ImageHandler image={itemImage2} onChange={(obj) => setItemImage2(obj.name)} />
                </Handlers>
                <Input
                  placeholder='Texto 2'
                  value={itemText2}
                  onChange={(e) => setItemText2(e.target.value)}
                />
              </Sector>
            </ModalBody>
            <ModalButtons>
              <Button secondary text='Cancelar' onClick={() => setShowItemModal(undefined)} />
              <Button
                primary
                text={showItemModal.submit}
                onClick={() =>
                  showItemModal.onSubmit({
                    text1: itemText1,
                    image1: itemImage1,
                    text2: itemText2,
                    image2: itemImage2,
                  })
                }
              />
            </ModalButtons>
          </ModalContainer>
        </ModalStyled>
      )}
      {state.map((item, index) => (
        <Wrapper key={index}>
          {isLoaded(item) ? (
            <>
              <Detail>
                <Sector>
                  {item.image1 && images[item.image1] && <ImageTiny src={images[item.image1]} />}
                  {item.text1 && <Text>{item.text1}</Text>}
                </Sector>
                -
                <Sector>
                  {item.image2 && images[item.image2] && <ImageTiny src={images[item.image2]} />}
                  {item.text2 && <Text>{item.text2}</Text>}
                </Sector>
              </Detail>
              <Options>
                <OptionIcon as={Delete} color='#c62828' onClick={() => onDeleteItem(index)} />
                <OptionIcon as={Edit} color='#1976d2' onClick={() => onEditItem(index)} />
              </Options>
            </>
          ) : (
            <Spinner src='loading.gif' />
          )}
        </Wrapper>
      ))}
      <WrapperAdd onClick={onAddItem}>
        <OptionIcon as={Add} color='#2196f3' />
      </WrapperAdd>
    </Container>
  );
};

const formatState = (state) => {
  let selected = {};
  let res = [];
  state.forEach((item, key) => {
    if (selected[key]) return;
    selected[key] = true;
    if (selected[item.pair]) return;
    selected[item.pair] = true;
    res.push({
      text1: item.text,
      image1: item.image,
      text2: state[item.pair].text,
      image2: state[item.pair].image,
    });
  });
  return res;
};

const translateState = (state) => {
  let pairs = [];

  state.map((item) => {
    pairs.push({
      text: item.text1,
      image: item.image1,
      pair: pairs.length + 1,
    });

    pairs.push({
      text: item.text2,
      image: item.image2,
      pair: pairs.length - 1,
    });
  });

  return pairs;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  padding: 15px 15px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  user-select: none;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  background-color: #caedff;
  margin-bottom: 10px;
`;

const WrapperAdd = styled.div`
  border-radius: 10px;
  border: 2px dashed #2196f3;
  min-height: 50px;
  width: 100%;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
`;

const Detail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    margin: 5px;
  }
`;

const Sector = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > * {
    margin: 5px;
  }
`;

const Handlers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  & > * {
    margin: 5px;
  }
`;

const ImageTiny = styled.img`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  border-radius: 10px;
  background-color: black;
  object-fit: contain;
`;

const Text = styled.div`
  font-size: 0.9em;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OptionIcon = styled.div`
  padding: 5px;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  cursor: pointer;
  fill: ${(props) => props.color || 'black'};
  :not(:last-child) {
    margin-right: 10px;
  }
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

const ModalStyled = styled(Modal)`
  max-width: 400px;
  width: 100%;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const ModalBody = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const ModalButtons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > * {
    margin: 5px;
  }

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export default LessonEditDataUnion;
